// @flow

import type { InstalmentsStrategy, CheckoutReceipts } from './types';

export function getInstalmentsStrategy(receipts: CheckoutReceipts): ?InstalmentsStrategy {
  return receipts.instalments_strategy;
}

export function getSafeInstalmentsStrategy(receipts: CheckoutReceipts): InstalmentsStrategy {
  const instalmentsStrategy = getInstalmentsStrategy(receipts);

  if (!instalmentsStrategy)
    throw new Error('getSafeInstalmentsStrategy: there is no "instalments_strategy" in the receipts');

  return instalmentsStrategy;
}
